import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { blue } from "@material-ui/core/colors";
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './store'
import registerServiceWorker from './registerServiceWorker';
import { Login } from './app/Login';
import { Top } from './app/Top';
import { Pattern } from './app/Pattern';
import { Product } from './app/Product';
import { Instruction } from './app/Instruction';
import { Spec } from './app/Spec';
import { Label } from './app/Label';
import { Colourway } from './app/Colourway';
import { Calculate } from './app/Calculate';
import { SaleOrderP } from './app/SaleOrderP';
import { OrderP } from './app/OrderP';
import { OrderMP } from './app/OrderMP';
import { RequestP } from './app/RequestP';
import { BuyP } from './app/BuyP';
import { BuyMP } from './app/BuyMP';
import { RecieveP } from './app/RecieveP';
import { SaleP } from './app/SaleP';
import { ShippingP } from './app/ShippingP';
import { InvestP } from './app/InvestP';
import { MoveP } from './app/MoveP';
import { AjustP } from './app/AjustP';
import { TransferP } from './app/TransferP';
import { InventoryP } from './app/InventoryP';
import { Material } from './app/Material';
import { SaleOrderR } from './app/SaleOrderR';
import { OrderR } from './app/OrderR';
import { RequestR } from './app/RequestR';
import { BuyR } from './app/BuyR';
import { RecieveR } from './app/RecieveR';
import { SaleR } from './app/SaleR';
import { ShippingR } from './app/ShippingR';
import { ProcOrderR } from './app/ProcOrderR';
import { ProcBuyR } from './app/ProcBuyR';
import { InvestR } from './app/InvestR';
import { MoveR } from './app/MoveR';
import { Ajust } from './app/Ajust';
import { TransferR } from './app/TransferR';
import { InventoryR } from './app/InventoryR';
import { SMaterial } from './app/SMaterial';
import { SaleOrderS } from './app/SaleOrderS';
import { OrderS } from './app/OrderS';
import { RequestS } from './app/RequestS';
import { BuyS } from './app/BuyS';
import { SaleS } from './app/SaleS';
import { RecieveS } from './app/RecieveS';
import { ShippingS } from './app/ShippingS';
import { InvestS } from './app/InvestS';
import { MoveS } from './app/MoveS';
import { AjustS } from './app/AjustS';
import { TransferS } from './app/TransferS';
import { InventoryS } from './app/InventoryS';
import { Expense } from './app/Expense';

import { Brand } from './app/Brand';
import { Item } from './app/Item';
import { Staff } from './app/Staff';
import { Section } from './app/Section';
import { Color } from './app/Color';
import { Size } from './app/Size';
import { Supplier } from './app/Supplier';
import { Client } from './app/Client';
import { Warehouse } from './app/Warehouse';
import { Demerit } from './app/Demerit';
import { Attention } from './app/Attention';
import { Code } from './app/Code';
import { Image } from './app/Image';
import { List } from './app/List';
import { Frame } from './app/Frame';
import { Performance } from './app/Performance';
import { StockFix } from './app/StockFix';
import { SlipFix } from './app/SlipFix';
import { Bases } from './app/Bases';
import { Forms } from './app/Forms';
import { Bulk } from './app/Bulk';
import { Information } from './app/Information';
import { ReleaseNote } from './app/ReleaseNote';
import './css/Basic.css'

//TSI
import { HinbanMaster } from './tsi/HinbanMaster';
import { MDtounyu } from './tsi/MDtounyu';
import { TenkaiMd } from './tsi/TenkaiMd';
import { RawM } from './tsi/RawM';
import { Approval } from './tsi/Approval';
import { ProdSched } from './tsi/ProdShed';
import { ShnOrder } from './tsi/ShnOrder';
import { Lists } from './tsi/Lists';
import { AuxMatBulk } from './tsi/AuxMatBulk';
import { AuxMatMst } from './tsi/AuxMatMst';
import { BrdCdMst } from './tsi/BrdCdMst';
import { BillInvPrint } from './tsi/BillInvPrint';
import { BLExpenseIn } from './tsi/BLExpenseIn';
import { BLInfoEntry } from './tsi/BLInfoEntry';
import { BudgetProg } from './tsi/BudgetProg';
import { CommonApprv } from './tsi/CommonApprv';
import { CompleteProc } from './tsi/CompleteProc';
import { CostLedger } from './tsi/CostLedger';
import { CostLogiMst } from './tsi/CostLogiMst';
import { DeliveryChk } from './tsi/DeliveryChk';
import { DeliveryDtl } from './tsi/DeliveryDtl';
import { DirectRetReg } from './tsi/DirectRetReg';
import { DirectTrade } from './tsi/DirectTrade';
import { ExpenseList } from './tsi/ExpenseList';
import { ExportInvIn } from './tsi/ExportInvIn';
import { FabricMst } from './tsi/FabricMst';
import { FabricReqBk } from './tsi/FabricReqBk';
import { FabricReqIn } from './tsi/FabricReqIn';
import { FabricStock } from './tsi/FabricStock';
import { FormDownload } from './tsi/FormDownload';
import { ImportInvIn } from './tsi/ImportInvIn';
import { ImportPayCfm } from './tsi/ImportPayCfm';
import { IncompList } from './tsi/IncompList';
import { IntTradeCtl } from './tsi/IntTradeCtl';
import { InvExpense } from './tsi/InvExpense';
import { InvoiceIn } from './tsi/InvoiceIn';
import { ItemBuyLedg } from './tsi/ItemBuyLedg';
import { JanCorpMst } from './tsi/JanCorpMst';
import { OverseasDel } from './tsi/OverseasDel';
import { PackListIn } from './tsi/PackListIn';
import { ProdPurchase } from './tsi/ProdPurchase';
import { ProdPurchaseR } from './tsi/ProdPurchaseR';
import { ProdPurchaseS } from './tsi/ProdPurchaseS';
import { ProdPurchaseV } from './tsi/ProdPurchaseV';
import { ProdSalesOrd } from './tsi/ProdSalesOrd';
import { ProdSmplDel } from './tsi/ProdSmplDel';
import { PurchaseRcpt } from './tsi/PurchaseRcpt';
import { QrcColorMap } from './tsi/QrcColorMap';
import { RawBalanceAdj } from './tsi/RawBalanceAdj';
import { RawCountBulk } from './tsi/RawCountBulk';
import { RawIntTrade } from './tsi/RawIntTrade';
import { RawMoveHist } from './tsi/RawMoveHist';
import { RawMoveIn } from './tsi/RawMoveIn';
import { RawProgress } from './tsi/RawProgress';
import { RawPurchase } from './tsi/RawPurchase';
import { RawSalesIn } from './tsi/RawSalesIn';
import { RawShipDtl } from './tsi/RawShipDtl';
import { RawSmplDel } from './tsi/RawSmplDel';
import { RawStockCnt } from './tsi/RawStockCnt';
import { RawStockList } from './tsi/RawStockList';
import { RawSupplyBk } from './tsi/RawSupplyBk';
import { RawSupplyIn } from './tsi/RawSupplyIn';
import { RawTransfer } from './tsi/RawTransfer';
import { SatoLabel } from './tsi/SatoLabel';
import { ShowStyleDtl } from './tsi/ShowStyleDtl';
import { SizeExpMst } from './tsi/SizeExpMst';
import { SizePtrnMst } from './tsi/SizePtrnMst';
import { StyleList } from './tsi/StyleList';
import { SuppPackList } from './tsi/SuppPackList';
import { TerminalOrd } from './tsi/TerminalOrd';
import { TorayIfChk } from './tsi/TorayIfChk';
import { TradeShowMst } from './tsi/TradeShowMst';
import { TrimMst } from './tsi/TrimMst';
import { WashPtrnMst } from './tsi/WashPtrnMst';
import { WorkProgMgr } from './tsi/WorkProgMgr';
import { MdInputCtrl } from './tsi/MdInputCtrl';
import { Kakousiji } from './tsi/Kakousiji';
import { Ternarymst } from './tsi/Ternarymst';
import { RawSupplyInBulk } from './tsi/RawSupplyInBulk';
import { MeiMst } from './tsi/MeiMst';
import { FactoryMst } from './tsi/FactoryMst';
import { BrandMst } from './tsi/BrandMst';
import { Swatch } from './tsi/Swatch';


import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-120367}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{AVAIL_Corporation.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{4}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{9_February_2027}____[v3]_[01]_MTgwMjEzMTIwMDAwMA==8bb904b12281e1d8a0964f4957fe53f0");

// <base href="./"> の属性値は相対のため、解決済みURLのパスを basename に使う
// (ルート直下では "/"、サブパス配置では "/kkaplite/" 等になり、同一ビルドで両対応)
const baseElement = document.getElementsByTagName('base')[0];
const baseUrl = baseElement ? new URL(baseElement.href).pathname : undefined;
const rootElement = document.getElementById('root');

const customTheme = createMuiTheme({
    mixins: {
        toolbar: {
            minHeight: 42
        }
    },
    palette: {
        // primary: blue
        primary: {
            main: blue[300]
        },
        secondary: {
            main: "#333"
        }
    },
    props: {
        MuiCheckbox: {
            color: "primary"
        },
        MuiList: {
            dense: true
        },
        MuiRadio: {
            color: "primary"
        },
        MuiSwitch: {
            color: "primary"
        },
        MuiListItem: {
            dense: true,
        },
        MuiTable: {
            size: "small"
        },
        MuiTextField: {
            margin: 'none',
            size:"small",
         InputProps: {
             style: {
                 fontSize: 11
                 }
             }
        }
    },
    typography: {
        // fontFamily: "Indie Flower",
        fontSize: 12,
        button: {
            textTransform: "none"
        }
    }
});

//To do auto reload when version change (npm run build and dotnet publish)
let currentVersion:string;
async function fetchCurrentVersion() {
    try {
        const response = await fetch('app-version.json');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const versionData = await response.json();
        currentVersion = versionData.version;
    } catch (error) {
        console.error('Error fetching current version:', error);
    }
}

// Fetch the current version when the app loads
fetchCurrentVersion().then(() => {
    // To check the currentVersion variable
    console.log('Current version:', currentVersion);

    // Start periodic update checks using setInterval
    setInterval(checkForUpdate, 5 * 1000); // Check every 5 sec
});

async function checkForUpdate() {
    try {
        const response = await fetch('app-version.json');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const latestVersionData = await response.json();

        // Compare latest version with the stored currentVersion
        if (latestVersionData.version !== currentVersion) {
            console.log('New version available. Reloading...');
            window.location.reload(); // Force a hard reload
        }
    } catch (error) {
        console.error('Error checking for updates:', error);
    }
}
// end of auto reload part


ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <MuiThemeProvider theme={customTheme}>
    {/*<App />*/}
        <Switch>
            <Route exact path="/" component={Login} />
            <Route path='/top' component={Top} />
            <Route path='/pattern' component={Pattern} />
            <Route path='/product' component={Product} />
            <Route path='/instruction' component={Instruction} />
            <Route path='/kakousiji' component={Kakousiji} />
            <Route path='/spec' component={Spec} />
            <Route path='/label' component={Label} />
            <Route path='/colourway' component={Colourway} />
            <Route path='/calculate' component={Calculate} />
            <Route path='/saleorderp' component={SaleOrderP} />
            <Route path='/orderp' component={OrderP} />
            <Route path='/ordermp' component={OrderMP} />
            <Route path='/requestp' component={RequestP} />
            <Route path='/buyp' component={BuyP} />
            <Route path='/buymp' component={BuyMP} />
            <Route path='/recievep' component={RecieveP} />
            <Route path='/shippingp' component={ShippingP} />
            <Route path='/salep' component={SaleP} />
            <Route path='/investp' component={InvestP} />
            <Route path='/movep' component={MoveP} />
            <Route path='/ajustp' component={Ajust} />
            <Route path='/transferp' component={TransferP} />
            <Route path='/inventoryp' component={InventoryP} />
            <Route path='/material' component={Material} />
            <Route path='/saleorderr' component={SaleOrderR} />
            <Route path='/orderr' component={OrderR} />
            <Route path='/requestr' component={RequestR} />
            <Route path='/buyr' component={BuyR} />
            <Route path='/reciever' component={RecieveR} />
            <Route path='/saler' component={SaleR} />
            <Route path='/shippingr' component={ShippingR} />
            <Route path='/procorderr' component={ProcOrderR} />
            <Route path='/procbuyr' component={ProcBuyR} />
            <Route path='/investr' component={InvestR} />
            <Route path='/mover' component={MoveR} />
            <Route path='/ajustr' component={Ajust} />
            <Route path='/transferr' component={TransferR} />
            <Route path='/inventoryr' component={InventoryR} />
            <Route path='/smaterial' component={SMaterial} />
            <Route path='/saleorders' component={SaleOrderS} />
            <Route path='/orders' component={OrderS} />
            <Route path='/requests' component={RequestS} />
            <Route path='/buys' component={BuyS} />
            <Route path='/recieves' component={RecieveS} />
            <Route path='/sales' component={SaleS} />
            <Route path='/shippings' component={ShippingS} />
            <Route path='/invests' component={InvestS} />
            <Route path='/moves' component={MoveS} />
            <Route path='/ajusts' component={Ajust} />
            <Route path='/transfers' component={TransferS} />
            <Route path='/inventorys' component={InventoryS} />
            <Route path='/expense' component={Expense} />
            <Route path='/brand' component={Brand} />
            <Route path='/item' component={Item} />
            <Route path='/staff' component={Staff} />
            <Route path='/section' component={Section} />
            <Route path='/color' component={Color} />
            <Route path='/size' component={Size} />
            <Route path='/supplier' component={Supplier} />
            <Route path='/client' component={Client} />
            <Route path='/warehouse' component={Warehouse} />
            <Route path='/demerit' component={Demerit} />
            <Route path='/attention' component={Attention} />
            <Route path='/code' component={Code} />
            <Route path='/image' component={Image} />
            <Route path='/stockfix' component={StockFix} />
            <Route path='/slipfix' component={SlipFix} />
            <Route path='/bases' component={Bases} />
            <Route path='/list' component={List} />
            <Route path='/frame' component={Frame} />
            <Route path='/forms' component={Forms} />
            <Route path='/bulk' component={Bulk} />
            <Route path='/performance' component={Performance} />
            <Route path='/information' component={Information} />
            <Route path='/ReleaseNote' component={ReleaseNote} />
            <Route path='/tenkaimd' component={TenkaiMd} />
            <Route path='/rawm' component={RawM} />
            <Route path='/mdtounyu' component={MDtounyu} />
            <Route path='/approval' component={Approval} />
            <Route path='/prodsched' component={ProdSched} />
            <Route path='/shnorder' component={ShnOrder} />
            <Route path='/hinbanmaster' component={HinbanMaster} />
            <Route path='/lists' component={Lists} />
            <Route path='/Approval' component={Approval} />
            <Route path='/AuxMatBulk' component={AuxMatBulk} />
            <Route path='/AuxMatMst' component={AuxMatMst} />
            <Route path='/BrdCdMst' component={BrdCdMst} />
            <Route path='/BillInvPrint' component={BillInvPrint} />
            <Route path='/BLExpenseIn' component={BLExpenseIn} />
            <Route path='/BLInfoEntry' component={BLInfoEntry} />
            <Route path='/BudgetProg' component={BudgetProg} />
            <Route path='/CommonApprv' component={CommonApprv} />
            <Route path='/CompleteProc' component={CompleteProc} />
            <Route path='/CostLedger' component={CostLedger} />
            <Route path='/CostLogiMst' component={CostLogiMst} />
            <Route path='/DeliveryChk' component={DeliveryChk} />
            <Route path='/DeliveryDtl' component={DeliveryDtl} />
            <Route path='/DirectRetReg' component={DirectRetReg} />
            <Route path='/DirectTrade' component={DirectTrade} />
            <Route path='/ExpenseList' component={ExpenseList} />
            <Route path='/ExportInvIn' component={ExportInvIn} />
            <Route path='/FabricMst' component={FabricMst} />
            <Route path='/FabricReqBk' component={FabricReqBk} />
            <Route path='/FabricReqIn' component={FabricReqIn} />
            <Route path='/FabricStock' component={FabricStock} />
            <Route path='/FormDownload' component={FormDownload} />
            <Route path='/ImportInvIn' component={ImportInvIn} />
            <Route path='/ImportPayCfm' component={ImportPayCfm} />
            <Route path='/IncompList' component={IncompList} />
            <Route path='/IntTradeCtl' component={IntTradeCtl} />
            <Route path='/InvExpense' component={InvExpense} />
            <Route path='/InvoiceIn' component={InvoiceIn} />
            <Route path='/ItemBuyLedg' component={ItemBuyLedg} />
            <Route path='/JanCorpMst' component={JanCorpMst} />
            <Route path='/Lists' component={Lists} />
            <Route path='/MDtounyu' component={MDtounyu} />
            <Route path='/TenkaiMd' component={TenkaiMd} />
            <Route path='/OverseasDel' component={OverseasDel} />
            <Route path='/PackListIn' component={PackListIn} />
            <Route path='/ProdPurchase' component={ProdPurchase} />
            <Route path='/ProdPurchaseR' component={ProdPurchaseR} />
            <Route path='/ProdPurchaseS' component={ProdPurchaseS} />
            <Route path='/ProdPurchaseV' component={ProdPurchaseV} />
            <Route path='/ProdSalesOrd' component={ProdSalesOrd} />
            <Route path='/ProdSmplDel' component={ProdSmplDel} />
            <Route path='/PurchaseRcpt' component={PurchaseRcpt} />
            <Route path='/QrcColorMap' component={QrcColorMap} />
            <Route path='/RawBalanceAdj' component={RawBalanceAdj} />
            <Route path='/RawCountBulk' component={RawCountBulk} />
            <Route path='/RawIntTrade' component={RawIntTrade} />
            <Route path='/RawM' component={RawM} />
            <Route path='/RawMoveHist' component={RawMoveHist} />
            <Route path='/RawMoveIn' component={RawMoveIn} />
            <Route path='/RawProgress' component={RawProgress} />
            <Route exact path='/RawPurchase' component={RawPurchase} />
            <Route path='/RawSalesIn' component={RawSalesIn} />
            <Route path='/RawShipDtl' component={RawShipDtl} />
            <Route path='/RawSmplDel' component={RawSmplDel} />
            <Route path='/RawStockCnt' component={RawStockCnt} />
            <Route path='/RawStockList' component={RawStockList} />
            <Route path='/RawSupplyBk' component={RawSupplyBk} />
            <Route path='/RawSupplyIn' component={RawSupplyIn} />
            <Route path='/RawTransfer' component={RawTransfer} />
            <Route path='/SatoLabel' component={SatoLabel} />
            <Route path='/ShnOrder' component={ShnOrder} />
            <Route path='/ShowStyleDtl' component={ShowStyleDtl} />
            <Route path='/SizeExpMst' component={SizeExpMst} />
            <Route path='/SizePtrnMst' component={SizePtrnMst} />
            <Route path='/StyleList' component={StyleList} />
            <Route path='/SuppPackList' component={SuppPackList} />
            <Route path='/TerminalOrd' component={TerminalOrd} />
            <Route path='/TorayIfChk' component={TorayIfChk} />
            <Route path='/TradeShowMst' component={TradeShowMst} />
            <Route path='/TrimMst' component={TrimMst} />
            <Route path='/WashPtrnMst' component={WashPtrnMst} />
            <Route path='/WorkProgMgr' component={WorkProgMgr} />
            <Route path='/MdInputCtrl' component={MdInputCtrl} />
            <Route path='/Ternarymst' component={Ternarymst} />
            <Route path='/RawSupplyInBulk' component={RawSupplyInBulk} />
            <Route path='/MeiMst' component={MeiMst} />
            <Route path='/FactoryMst' component={FactoryMst} />
            <Route path='/BrandMst' component={BrandMst} />
            <Route path='/Swatch' component={Swatch} />
  </Switch>
    </MuiThemeProvider>
    </PersistGate>
    </Provider>
  </BrowserRouter>,
  rootElement
);

registerServiceWorker();
